import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import PopulationIndex from "./PopulationIndex";
import SEO from "../../../UI/SEO/SEO";
import PopulationDetail from "./PopulationDetail";
// Paths
export const getPopulationBasePath = () => `${getAdminBasePath()}/population`;
export const getPopulationSharedFiltersDetailPath = (populationId) => getPopulationBasePath() + "/" + populationId;
// Routes
export const getPopulationBaseRoute = () => `${getAdminBaseRoute()}/population`;
export const getPopulationSharedFiltersDetailRoute = () => `${getPopulationBaseRoute()}/:id`;
const AdminPopulationRoutes = () => {
    return (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Filters" }), _jsxs(Switch, { children: [_jsx(Route, { component: PopulationDetail, path: getPopulationSharedFiltersDetailRoute() }), _jsx(Route, { component: PopulationIndex, path: getPopulationBaseRoute() })] })] }));
};
export default AdminPopulationRoutes;
